import { useEffect, useState} from "react";
import ticketService from "../services/ticketService";
import useAuth from "../hooks/useAuth";
import TicketQrCard from "../Components/TicketQrCard";
import { Link } from "react-router-dom";
import { LuTicket, LuLogIn } from "react-icons/lu";

function Tickets() {
    const { user, isAuthenticated } = useAuth();
    const [tokenValid, setTokenValid ] = useState(true)
    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        async function fetchData() {
            if (isAuthenticated) {
                const response = await ticketService.getTicketsForUser(user.id);
                if(response.status === 500){
                    setTokenValid(false)
                }else{
                    setTickets(response);
                }
            }
        }
        try {
            fetchData();
        } catch (error) {
            console.log(error);
        }
    }, [isAuthenticated, user]);

    return (
        <div className="relative min-h-screen overflow-hidden bg-zinc-950">
            <div
                className="pointer-events-none absolute inset-0 opacity-70"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 15% 20%, rgba(253, 191, 4, 0.20), transparent 34%), radial-gradient(circle at 85% 15%, rgba(234, 179, 8, 0.14), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                }}
            />
            <div className="relative mx-auto min-h-screen max-w-6xl px-4 pt-24">
                {isAuthenticated && tokenValid ? (
                    tickets?.length > 0 ? (
                        tickets?.map((ticket) => {
                            return (
                                <TicketQrCard key={ticket.id} ticket={ticket} />
                            );
                        })
                    ) : (
                        <section className="mx-auto mt-10 flex min-h-[58vh] w-full max-w-3xl items-center justify-center">
                            <div className="w-full rounded-3xl border border-zinc-800 bg-zinc-900/65 p-8 text-center shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                                <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-zinc-800 text-yellow-cdg">
                                    <LuTicket className="text-2xl" />
                                </div>
                                <h1 className="text-3xl font-bold text-white">
                                    Todavía no tenés tickets
                                </h1>
                                <p className="mx-auto mt-3 max-w-xl text-zinc-300">
                                    Cuando compres entradas, las vas a encontrar acá con su código QR listas para usar.
                                </p>
                                <div className="mt-7 flex justify-center">
                                    <Link
                                        to={"/eventos"}
                                        className="rounded-xl bg-gradient-to-r from-yellow-cdg to-amber-500 px-5 py-2.5 font-medium text-zinc-900 shadow-[0_10px_20px_rgba(253,191,4,0.25)] transition-transform hover:scale-[1.02]"
                                    >
                                        Explorar eventos
                                    </Link>
                                </div>
                            </div>
                        </section>
                    )
                ) : (
                    <section className="mx-auto mt-10 flex min-h-[58vh] w-full max-w-3xl items-center justify-center">
                        <div className="w-full rounded-3xl border border-zinc-800 bg-zinc-900/65 p-8 text-center shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-zinc-800 text-yellow-cdg">
                                <LuLogIn className="text-2xl" />
                            </div>
                            <h1 className="text-3xl font-bold text-white">
                                Sesión expirada
                            </h1>
                            <p className="mx-auto mt-3 max-w-xl text-zinc-300">
                                Volvé a iniciar sesión para ver tus entradas y gestionar tus compras.
                            </p>
                            <div className="mt-7 flex justify-center gap-3">
                                <Link
                                    to={"/login"}
                                    className="rounded-xl bg-gradient-to-r from-yellow-cdg to-amber-500 px-5 py-2.5 font-medium text-zinc-900 shadow-[0_10px_20px_rgba(253,191,4,0.25)] transition-transform hover:scale-[1.02]"
                                >
                                    Iniciar sesión
                                </Link>
                                <Link
                                    to={"/eventos"}
                                    className="rounded-xl border border-zinc-700 bg-zinc-900/70 px-5 py-2.5 font-medium text-zinc-100 transition-colors hover:border-zinc-500 hover:bg-zinc-800"
                                >
                                    Ver eventos
                                </Link>
                            </div>
                        </div>
                    </section>
                )}
            </div>
        </div>
    );
}

export default Tickets;
